<a *ngIf="show && !diabled"
  href="{{url}}"
  target="_blank"
  rel="noopener noreferrer"
  severity="info"
  class="p-button font-bold p-button-outlined">
    View
    <i class="pi pi-file ml-1"></i>
</a>
